import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SkillArchitectureDTO } from '../models/skill-architecture-form';

@Injectable({
    providedIn: 'root',
})
export class SkillArchitectureService {
    // TODO: create base class for services
    readonly restUrl: string;

    constructor(private http: HttpClient) {
        this.restUrl = environment.backendUrl + '/rest/training';
    }

    getSkillArchitectureFormData(
        trainingId: string
    ): Observable<SkillArchitectureDTO> {
        const url = this.createUrl(trainingId);
        return this.http.get<SkillArchitectureDTO>(url);
    }

    saveSkillArchitectureFormData(
        trainingId: string,
        skillArchitectureDTO: SkillArchitectureDTO
    ) {
        const url = this.createUrl(trainingId);

        console.log('Sending to url', url);

        return this.http.patch<SkillArchitectureDTO>(url, skillArchitectureDTO);
    }

    private createUrl(trainingId: string): string {
        return `${this.restUrl}/${trainingId}/skill-architecture`;
    }
}
